(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'react', '../Buttons', './SplitButtonMenu.container', './SplitButton.styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('../Buttons'), require('./SplitButtonMenu.container'), require('./SplitButton.styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.Buttons, global.SplitButtonMenu, global.SplitButton);
    global.SplitButton = mod.exports;
  }
})(this, function (exports, _extends2, _objectWithoutProperties2, _react, _Buttons, _SplitButtonMenu, _SplitButton) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _react2 = _interopRequireDefault(_react);

  var _SplitButtonMenu2 = _interopRequireDefault(_SplitButtonMenu);

  var _SplitButton2 = _interopRequireDefault(_SplitButton);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SplitButton = function SplitButton(_ref) {
    var splitButtonConfig = _ref.splitButtonConfig,
        children = _ref.children,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['splitButtonConfig', 'children']);
    return _react2.default.createElement(
      'div',
      { className: _SplitButton2.default.splitButton },
      _react2.default.createElement(
        _Buttons.ButtonSecondarySmall,
        (0, _extends3.default)({
          'data-test': 'click-split-button-primary',
          onClick: function onClick(event) {
            splitButtonConfig.primaryButtonHandler(event);
          },
          className: _SplitButton2.default.buttonPrimary
        }, rest),
        children
      ),
      _react2.default.createElement(_SplitButtonMenu2.default, (0, _extends3.default)({
        menuItems: splitButtonConfig.menuItems
      }, rest))
    );
  };

  exports.default = SplitButton;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/SplitButton/SplitButton.js
// module id = 1940
// module chunks = 1